/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect } from 'react';
import { PAGE_CONFIG } from './PageConfig/Pc_Common';
// import { PAGE_CONFIG_TEST } from './pageConfigTest';
// import { PAGE_CONFIG } from './funcomPageConfig';
// import {PAGE_CONFIG} from './PageConfig/SyboGames';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import './OpinionsStudioV2/index.scss';
import './index.scss';
import { useParams } from 'umi';

const OpinionIndex = () => {
  const { studioId, gameCode } = useParams() || {} as any;
  return (
    <CommonPageRender
      reqParams={'/opinionIndex'}
      key={studioId + gameCode}
      className="dbh-studio-opinion-index-page"
      frameType='game'
      // @ts-ignore
      pageConfigInit={PAGE_CONFIG}
      api={PAGE_CONFIG_API}
    />
  );
};

export default OpinionIndex;
